"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.signOperationWithAPI = void 0;
var rxjs_1 = require("rxjs");
var deviceAccess_1 = require("../../hw/deviceAccess");
var js_buildTransaction_1 = require("./js-buildTransaction");
var hw_app_solana_1 = __importDefault(require("@ledgerhq/hw-app-solana"));
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var operation_1 = require("../../operation");
var utils_1 = require("./utils");
var buildOptimisticOperation = function (account, transaction) {
    var _a, _b, _c, _d;
    if (transaction.model.commandDescriptor === undefined) {
        throw new Error("command descriptor is missing");
    }
    var commandDescriptor = transaction.model.commandDescriptor;
    if (Object.keys(commandDescriptor.errors).length > 0) {
        throw new Error("invalid command");
    }
    var optimisticOp = buildOptimisticOperationForCommand(account, transaction, commandDescriptor);
    var lastOpSeqNumber = (_d = (_b = (_a = account.pendingOperations[0]) === null || _a === void 0 ? void 0 : _a.transactionSequenceNumber) !== null && _b !== void 0 ? _b : (_c = account.operations[0]) === null || _c === void 0 ? void 0 : _c.transactionSequenceNumber) !== null && _d !== void 0 ? _d : 0;
    optimisticOp.transactionSequenceNumber = lastOpSeqNumber + 1;
    return optimisticOp;
};
var signOperationWithAPI = function (_a, api) {
    var account = _a.account, deviceId = _a.deviceId, transaction = _a.transaction;
    return (0, deviceAccess_1.withDevice)(deviceId)(function (transport) {
        return new rxjs_1.Observable(function (subscriber) {
            var main = function () { return __awaiter(void 0, void 0, void 0, function () {
                var _a, tx, signOnChainTransaction, _b, _c, hwApp, signature, signedTx;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            _b = js_buildTransaction_1.buildTransactionWithAPI;
                            _c = [account,
                                transaction];
                            return [4 /*yield*/, api()];
                        case 1: return [4 /*yield*/, _b.apply(void 0, _c.concat([_d.sent()]))];
                        case 2:
                            _a = __read.apply(void 0, [_d.sent(), 2]), tx = _a[0], signOnChainTransaction = _a[1];
                            hwApp = new hw_app_solana_1["default"](transport);
                            subscriber.next({
                                type: "device-signature-requested"
                            });
                            return [4 /*yield*/, hwApp.signTransaction(account.freshAddressPath, tx.compileMessage().serialize())];
                        case 3:
                            signature = (_d.sent()).signature;
                            subscriber.next({
                                type: "device-signature-granted"
                            });
                            signedTx = signOnChainTransaction(signature);
                            subscriber.next({
                                type: "signed",
                                signedOperation: {
                                    operation: buildOptimisticOperation(account, transaction),
                                    signature: signedTx.serialize().toString("hex"),
                                    expirationDate: null
                                }
                            });
                            return [2 /*return*/];
                    }
                });
            }); };
            main().then(function () { return subscriber.complete(); }, function (e) { return subscriber.error(e); });
        });
    });
};
exports.signOperationWithAPI = signOperationWithAPI;
function buildOptimisticOperationForCommand(account, transaction, commandDescriptor) {
    var command = commandDescriptor.command;
    switch (command.kind) {
        case "transfer":
            return optimisticOpForTransfer(account, transaction, command, commandDescriptor);
        case "token.transfer":
            return optimisticOpForTokenTransfer(account, transaction, command, commandDescriptor);
        case "token.createATA":
            return optimisticOpForCATA(account, commandDescriptor);
        case "stake.createAccount":
            return optimisticOpForStakeCreateAccount(account, transaction, command, commandDescriptor);
        case "stake.delegate":
            return optimisticOpForStakeDelegate(account, command, commandDescriptor);
        case "stake.undelegate":
            return optimisticOpForStakeUndelegate(account, command, commandDescriptor);
        case "stake.withdraw":
            return optimisticOpForStakeWithdraw(account, command, commandDescriptor);
        case "stake.split":
            return optimisticOpForStakeSplit(account, command, commandDescriptor);
        default:
            return (0, utils_1.assertUnreachable)(command);
    }
}
function optimisticOpForTransfer(account, transaction, command, commandDescriptor) {
    var commons = optimisticOpcommons(commandDescriptor);
    return __assign(__assign({}, commons), { id: (0, operation_1.encodeOperationId)(account.id, "", "OUT"), type: "OUT", accountId: account.id, senders: [account.freshAddress], recipients: [transaction.recipient], value: new bignumber_js_1["default"](command.amount).plus(commons.fee), extra: getOpExtras(command) });
}
function optimisticOpForTokenTransfer(account, transaction, command, commandDescriptor) {
    if (!transaction.subAccountId) {
        throw new Error("sub account id is required for token transfer");
    }
    return __assign(__assign({}, optimisticOpcommons(commandDescriptor)), { id: (0, operation_1.encodeOperationId)(account.id, "", "FEES"), type: "FEES", accountId: account.id, senders: [account.freshAddress], recipients: [transaction.recipient], value: new bignumber_js_1["default"](command.amount), extra: getOpExtras(command), subOperations: [
            __assign(__assign({}, optimisticOpcommons(commandDescriptor)), { id: (0, operation_1.encodeOperationId)(transaction.subAccountId, "", "OUT"), type: "OUT", accountId: transaction.subAccountId, senders: [account.freshAddress], recipients: [transaction.recipient], value: new bignumber_js_1["default"](command.amount), extra: getOpExtras(command) }),
        ] });
}
function optimisticOpForCATA(account, commandDescriptor) {
    var opType = "OPT_IN";
    return __assign(__assign({}, optimisticOpcommons(commandDescriptor)), { id: (0, operation_1.encodeOperationId)(account.id, "", opType), type: opType, accountId: account.id, senders: [], recipients: [], value: new bignumber_js_1["default"](commandDescriptor.fee) });
}
function optimisticOpcommons(commandDescriptor) {
    return {
        hash: "",
        fee: new bignumber_js_1["default"](commandDescriptor.fee),
        blockHash: null,
        blockHeight: null,
        date: new Date(),
        extra: {}
    };
}
function getOpExtras(command) {
    var extra = {};
    switch (command.kind) {
        case "transfer":
        case "token.transfer":
            if (command.memo !== undefined) {
                extra.memo = command.memo;
            }
            break;
        case "token.createATA":
        case "stake.createAccount":
        case "stake.delegate":
        case "stake.undelegate":
        case "stake.withdraw":
        case "stake.split":
            break;
        default:
            return (0, utils_1.assertUnreachable)(command);
    }
    return extra;
}
function optimisticOpForStakeCreateAccount(account, transaction, command, commandDescriptor) {
    var opType = "DELEGATE";
    var commons = optimisticOpcommons(commandDescriptor);
    return __assign(__assign({}, commons), { id: (0, operation_1.encodeOperationId)(account.id, "", opType), type: opType, accountId: account.id, senders: [], recipients: [], value: new bignumber_js_1["default"](command.amount).plus(commons.fee), extra: getOpExtras(command) });
}
function optimisticOpForStakeDelegate(account, command, commandDescriptor) {
    var commons = optimisticOpcommons(commandDescriptor);
    var opType = "DELEGATE";
    return __assign(__assign({}, commons), { id: (0, operation_1.encodeOperationId)(account.id, "", opType), type: opType, accountId: account.id, senders: [], recipients: [], value: commons.fee, extra: getOpExtras(command) });
}
function optimisticOpForStakeUndelegate(account, command, commandDescriptor) {
    var commons = optimisticOpcommons(commandDescriptor);
    var opType = "UNDELEGATE";
    return __assign(__assign({}, commons), { id: (0, operation_1.encodeOperationId)(account.id, "", opType), type: opType, accountId: account.id, senders: [], recipients: [], value: commons.fee, extra: getOpExtras(command) });
}
function optimisticOpForStakeWithdraw(account, command, commandDescriptor) {
    var commons = optimisticOpcommons(commandDescriptor);
    var opType = "IN";
    return __assign(__assign({}, commons), { id: (0, operation_1.encodeOperationId)(account.id, "", opType), type: opType, accountId: account.id, senders: [command.stakeAccAddr], recipients: [command.toAccAddr], value: new bignumber_js_1["default"](command.amount).minus(commons.fee), extra: getOpExtras(command) });
}
function optimisticOpForStakeSplit(account, command, commandDescriptor) {
    var commons = optimisticOpcommons(commandDescriptor);
    var opType = "OUT";
    return __assign(__assign({}, commons), { id: (0, operation_1.encodeOperationId)(account.id, "", opType), type: opType, accountId: account.id, senders: [command.stakeAccAddr], recipients: [command.splitStakeAccAddr], value: commons.fee, extra: getOpExtras(command) });
}
//# sourceMappingURL=js-signOperation.js.map